import type { JSONContent } from '@tiptap/core';
import type { EChartsOption } from 'echarts';
import { v4 as uuid } from 'uuid';
import { ContentBlockType, EchartsBlock } from '../../model';
import { BlockToTiptapConverter } from '../blocks-to-tiptap.converter';

export const convertEchartsBlockToTiptap = ((block) => {
  const hasNumericHeight = typeof block.height === 'number' && Number.isFinite(block.height);

  return {
    type: 'echarts',
    attrs: {
      id: block.id,
      options: block.options,
      ...(hasNumericHeight && { height: block.height }),
      ...(block.custom_css && { custom_css: block.custom_css }),
      ...(block.custom_style && { custom_style: block.custom_style }),
    },
  };
}) satisfies BlockToTiptapConverter<EchartsBlock>;

export function convertTiptapToEchartsBlock(json: JSONContent): EchartsBlock {
  const attrs = json.attrs ?? {};
  const rawHeight = attrs['height'];
  const hasNumericHeight = typeof rawHeight === 'number' && Number.isFinite(rawHeight);

  return {
    id: (attrs['id'] as string) ?? uuid(),
    type: ContentBlockType.Echarts,
    options: (attrs['options'] as EChartsOption) ?? {},
    ...(hasNumericHeight && { height: rawHeight }),
    ...(attrs['custom_css'] && { custom_css: attrs['custom_css'] as string }),
    ...(attrs['custom_style'] && { custom_style: attrs['custom_style'] as Record<string, string> }),
  };
}
